import { render, staticRenderFns } from "./EdicionIndiceTematico.vue?vue&type=template&id=5a84e28d&scoped=true"
import script from "./EdicionIndiceTematico.vue?vue&type=script&lang=js"
export * from "./EdicionIndiceTematico.vue?vue&type=script&lang=js"
import style0 from "./EdicionIndiceTematico.vue?vue&type=style&index=0&id=5a84e28d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a84e28d",
  null
  
)

export default component.exports